"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sumAndAverageAggregatedBatteryData = exports.splitCoordinatesOnUnexpectedDelta = exports.sortCoordinatesDescending = exports.organizeBatteryReadingsByNumber = exports.jsToDateTime = exports.isValueNotNull = exports.isValidReadingWithValue = exports.isValidReadingWithPositiveValue = exports.isValidReading = exports.isReadingEstimated = exports.isNumeric = exports.isCoordinateWithinRange = exports.getXY = exports.getTickInfoByInterval = exports.getMinMaxRangeFromDisplayCoordinates = exports.getFulfillmentPercentDiff = exports.getFormattedValue = exports.combineFieldServiceActivityByCase = void 0;

var _luxon = require("luxon");

var _lodash = require("lodash");

var _max = _interopRequireDefault(require("lodash/max"));

var _min = _interopRequireDefault(require("lodash/min"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *
 * @param  nativeEvent
 */
var getXY = function getXY(nativeEvent) {
  var x = nativeEvent.type === 'touchstart' ? nativeEvent.pageX : nativeEvent.offsetX;
  var y = nativeEvent.type === 'touchstart' ? nativeEvent.pageY : nativeEvent.offsetY;
  return {
    x: x,
    y: y
  };
};

exports.getXY = getXY;

var averageReadingList = function averageReadingList(readings) {
  return readings.reduce(function (acc, num) {
    return acc + num;
  }, 0) / readings.length;
};

var sumReadingList = function sumReadingList(readings) {
  return readings.reduce(function (acc, num) {
    return acc + num;
  }, 0);
};

var sumAndAverageAggregatedBatteryData = function sumAndAverageAggregatedBatteryData(batteries) {
  var concatPerformance = batteries.reduce(function (acc, battery) {
    var newAcc = acc.concat(battery.performanceData);
    return newAcc;
  }, []);
  var concatReadings = concatPerformance.reduce(function (dictionary, reading) {
    if (dictionary[reading.timestamp]) {
      var _dictionary$reading$t = dictionary[reading.timestamp],
          averageBatteryPercentageState = _dictionary$reading$t.averageBatteryPercentageState,
          averagePowerKw = _dictionary$reading$t.averagePowerKw,
          energyChargedKwh = _dictionary$reading$t.energyChargedKwh,
          energyDischargedKwh = _dictionary$reading$t.energyDischargedKwh,
          maxBatteryPercentageState = _dictionary$reading$t.maxBatteryPercentageState,
          minBatteryPercentageState = _dictionary$reading$t.minBatteryPercentageState,
          timestamp = _dictionary$reading$t.timestamp,
          startDateUtc = _dictionary$reading$t.startDateUtc;
      dictionary[timestamp] = {
        averageBatteryPercentageState: averageBatteryPercentageState.concat(isNaN(reading.averageBatteryPercentageState) ? [] : [Number(reading.averageBatteryPercentageState)]).flat(),
        averagePowerKw: averagePowerKw.concat(isNaN(reading.averagePowerKw) ? [0] : [Number(reading.averagePowerKw)]).flat(),
        energyChargedKwh: energyChargedKwh.concat(isNaN(reading.energyChargedKwh) ? [0] : [Number(reading.energyChargedKwh)]).flat(),
        energyDischargedKwh: energyDischargedKwh.concat(isNaN(reading.energyDischargedKwh) ? [0] : [Number(reading.energyDischargedKwh)]).flat(),
        minBatteryPercentageState: minBatteryPercentageState.concat(isNaN(reading.minBatteryPercentageState) ? [] : [Number(reading.minBatteryPercentageState)]).flat(),
        maxBatteryPercentageState: maxBatteryPercentageState.concat(isNaN(reading.maxBatteryPercentageState) ? [] : [Number(reading.maxBatteryPercentageState)]).flat(),
        timestamp: timestamp,
        startDateUtc: startDateUtc
      };
      return dictionary;
    }

    dictionary[reading.timestamp] = {
      averageBatteryPercentageState: [isNaN(reading.averageBatteryPercentageState) ? [] : Number(reading.averageBatteryPercentageState)],
      averagePowerKw: [isNaN(reading.averagePowerKw) ? 0 : Number(reading.averagePowerKw)],
      energyChargedKwh: [isNaN(reading.energyChargedKwh) ? 0 : Number(reading.energyChargedKwh)],
      energyDischargedKwh: [isNaN(reading.energyDischargedKwh) ? 0 : Number(reading.energyDischargedKwh)],
      minBatteryPercentageState: [isNaN(reading.minBatteryPercentageState) ? [] : Number(reading.minBatteryPercentageState)],
      maxBatteryPercentageState: [isNaN(reading.maxBatteryPercentageState) ? [] : Number(reading.maxBatteryPercentageState)],
      timestamp: reading.timestamp,
      startDateUtc: reading.startDateUtc
    };
    return dictionary;
  }, {});
  return Object.values(concatReadings).map(function (reading) {
    return {
      averageBatteryPercentageState: averageReadingList(reading.averageBatteryPercentageState),
      averagePowerKw: sumReadingList(reading.averagePowerKw),
      energyChargedKwh: sumReadingList(reading.energyChargedKwh),
      energyDischargedKwh: sumReadingList(reading.energyDischargedKwh),
      minBatteryPercentageState: averageReadingList(reading.minBatteryPercentageState),
      maxBatteryPercentageState: averageReadingList(reading.maxBatteryPercentageState),
      timestamp: reading.timestamp,
      startDateUtc: reading.startDateUtc
    };
  });
};

exports.sumAndAverageAggregatedBatteryData = sumAndAverageAggregatedBatteryData;

var organizeBatteryReadingsByNumber = function organizeBatteryReadingsByNumber(batteries) {
  return batteries.reduce(function (batteryDictionary, battery, index) {
    var _battery$performanceD;

    if (!(battery !== null && battery !== void 0 && (_battery$performanceD = battery.performanceData) !== null && _battery$performanceD !== void 0 && _battery$performanceD.length)) return batteryDictionary;
    batteryDictionary["Battery ".concat(index + 1)] = sumAndAverageAggregatedBatteryData([battery]);
    return batteryDictionary;
  }, {});
};

exports.organizeBatteryReadingsByNumber = organizeBatteryReadingsByNumber;

var isNumeric = function isNumeric(number) {
  return !isNaN(number);
};

exports.isNumeric = isNumeric;

var isValueNotNull = function isValueNotNull(value) {
  return value !== null;
};

exports.isValueNotNull = isValueNotNull;

var isValidReading = function isValidReading(fieldName) {
  return function (reading) {
    return isNumeric(reading[fieldName]) && isValueNotNull(reading[fieldName]);
  };
}; // Bettery percentages have to have a value above zero


exports.isValidReading = isValidReading;

var isValidReadingWithValue = function isValidReadingWithValue(fieldName) {
  var isValidReadingPartial = isValidReading(fieldName);
  return function (reading) {
    return isValidReadingPartial(reading) && Number(reading[fieldName]) > 0;
  };
}; // Many other power and energy fields just can't be negative


exports.isValidReadingWithValue = isValidReadingWithValue;

var isValidReadingWithPositiveValue = function isValidReadingWithPositiveValue(fieldName) {
  var isValidReadingPartial = isValidReading(fieldName);
  return function (reading) {
    return isValidReadingPartial(reading) && Number(reading[fieldName]) >= 0;
  };
};

exports.isValidReadingWithPositiveValue = isValidReadingWithPositiveValue;

var isReadingEstimated = function isReadingEstimated(reading) {
  return reading.source && reading.source.isEstimated === 'true';
};

exports.isReadingEstimated = isReadingEstimated;

var isCoordinateWithinRange = function isCoordinateWithinRange(_ref, coordinate) {
  var startMillis = _ref.startMillis,
      endMillis = _ref.endMillis;
  return coordinate.x0 && coordinate.x0 >= startMillis && coordinate.x0 <= endMillis || coordinate.x >= startMillis && coordinate.x <= endMillis;
};

exports.isCoordinateWithinRange = isCoordinateWithinRange;

var isLessThanOrEqualToDelta = function isLessThanOrEqualToDelta(moreRecentCoord, lessRecentCoord, expectedDelta) {
  // First check the difference in milliseconds, this is usually sufficient
  var isLessThanOrEqualInMillis = Math.abs(moreRecentCoord.x - lessRecentCoord.x) <= expectedDelta.as('milliseconds');

  if (isLessThanOrEqualInMillis) {
    return true;
  } // Sometimes the milliseconds may not be less than or equal, but the units we are comparing still are (for example, one day difference)
  // Only construct DateTime objects if necessary as this tends to be expensive when doing lots of operations


  var moreRecentDateTime = _luxon.DateTime.fromMillis(moreRecentCoord.x);

  var lessRecentDateTime = _luxon.DateTime.fromMillis(lessRecentCoord.x);

  var units = Object.keys(expectedDelta.values);
  var delta = moreRecentDateTime.diff(lessRecentDateTime, units);

  if (delta.equals(expectedDelta)) {
    return true;
  }

  return false;
};
/**
 * Takes an array of coordinates and splits into multiple arrays when there are gaps in the data.
 * Gap is defined by a delta, expressed as a duration.
 * @param {Array} coordinates Array of x,y coordinates, x being milliseconds. Must be sorted with most recent dates first
 * @param {Duration} expectedDelta Expected delta between coordinates, expressed as Luxon Duration
 */


var splitCoordinatesOnUnexpectedDelta = function splitCoordinatesOnUnexpectedDelta(coordinates, expectedDelta) {
  // {x , y} coordinates with x as milliseconds
  if (!coordinates || coordinates.length === 0) {
    return [];
  }

  return coordinates.reduce(function (groupedCoords, lessRecentCoord, index) {
    var moreRecentCoordinate = coordinates[index - 1];

    if (!moreRecentCoordinate) {
      groupedCoords.push([lessRecentCoord]);
    } else if (isLessThanOrEqualToDelta(moreRecentCoordinate, lessRecentCoord, expectedDelta)) {
      var lastArrayInGroup = groupedCoords[groupedCoords.length - 1];
      lastArrayInGroup.push(lessRecentCoord);
    } else {
      // If it's larger than the delta, split into a new collection by creating a new array with coordinate and pushing at end of group
      var newGroup = [lessRecentCoord];
      groupedCoords.push(newGroup);
    }

    return groupedCoords;
  }, []);
};

exports.splitCoordinatesOnUnexpectedDelta = splitCoordinatesOnUnexpectedDelta;

var getDatesBetween = function getDatesBetween(dateRange, settings, timeMeasurement) {
  var startDate = dateRange.startDate,
      endDate = dateRange.endDate;
  var timeBetween = Math.ceil(endDate.diff(startDate, timeMeasurement).values[timeMeasurement]) + 1;
  var datesAtMidnight = (0, _lodash.range)(timeBetween).map(function (x, index) {
    var setting = startDate.plus(_defineProperty({}, timeMeasurement, index)).set(settings).toMillis();
    return startDate > setting || setting > endDate ? 0 : setting;
  });
  return datesAtMidnight;
};

var tickFormatter = function tickFormatter(base, alt, comp, timeZone) {
  return function (t, i) {
    var dateTime = _luxon.DateTime.fromMillis(t, {
      zone: timeZone
    });

    var baseFormat = dateTime.toFormat(base);

    if (i === 0 || baseFormat === comp) {
      return dateTime.toFormat(alt);
    }

    return baseFormat;
  };
};

var getTickInfoByInterval = function getTickInfoByInterval(_ref2) {
  var endDate = _ref2.endDate,
      startDate = _ref2.startDate,
      timeZone = _ref2.timeZone;

  var displayInterval = _luxon.Interval.fromDateTimes(startDate, endDate);

  var numberOfDays = displayInterval.count('days');
  var numberOfMonths = displayInterval.count('months');

  if (numberOfDays < 60) {
    return {
      values: getDatesBetween({
        startDate: startDate,
        endDate: endDate
      }, {
        hour: 0
      }, 'days'),
      formats: tickFormatter('d', 'LLL', '1', timeZone)
    };
  }

  if (numberOfMonths < 12) {
    return {
      values: getDatesBetween({
        startDate: startDate,
        endDate: endDate
      }, {
        day: 1
      }, 'months'),
      formats: tickFormatter('LLL', 'LLL', null, timeZone)
    };
  }

  if (numberOfMonths < 36) {
    return {
      values: getDatesBetween({
        startDate: startDate,
        endDate: endDate
      }, {
        day: 1
      }, 'months'),
      formats: tickFormatter('LLL', 'y', 'Jan', timeZone)
    };
  }

  return {
    values: getDatesBetween({
      startDate: startDate,
      endDate: endDate
    }, {
      month: 1
    }, 'years'),
    formats: tickFormatter('y', 'y', null, timeZone)
  };
};

exports.getTickInfoByInterval = getTickInfoByInterval;

var getFormattedValue = function getFormattedValue(value, decimals) {
  return parseFloat(value).toLocaleString('en-US', {
    maximumFractionDigits: decimals
  });
};

exports.getFormattedValue = getFormattedValue;

var getFulfillmentPercentDiff = function getFulfillmentPercentDiff(powerSource, maxCoordinate) {
  if (!maxCoordinate) return false;
  if (!powerSource) return '0';
  return (powerSource / maxCoordinate * 100).toFixed(1).toString();
};

exports.getFulfillmentPercentDiff = getFulfillmentPercentDiff;

var sortCoordinatesDescending = function sortCoordinatesDescending(c1, c2) {
  return c2.x < c1.x ? -1 : 1;
};

exports.sortCoordinatesDescending = sortCoordinatesDescending;

var combineFieldServiceActivityByCase = function combineFieldServiceActivityByCase(fieldServiceActivity) {
  var groupedCaseNumbers = fieldServiceActivity.reduce(function (caseDictionary, c) {
    if (!caseDictionary[c.caseNumber]) {
      // eslint-disable-next-line no-param-reassign
      caseDictionary[c.caseNumber] = _objectSpread({
        actionCodeNames: [],
        actionNames: [],
        componentCodeNames: [],
        dispatchNames: [],
        findings: []
      }, c);
    }

    caseDictionary[c.caseNumber].actionCodeNames.push(c.actionCodeName);
    caseDictionary[c.caseNumber].actionNames.push({
      name: c.actionName,
      id: c.actionId
    });
    caseDictionary[c.caseNumber].componentCodeNames.push(c.componentCodeName);
    caseDictionary[c.caseNumber].dispatchNames.push({
      name: c.dispatchName,
      id: c.dispatchId
    });
    caseDictionary[c.caseNumber].findings.push(c.dispatchFindings);
    return caseDictionary;
  }, {});
  var combinedStages = Object.values(groupedCaseNumbers);
  return combinedStages;
};

exports.combineFieldServiceActivityByCase = combineFieldServiceActivityByCase;

var getMinMaxRangeFromDisplayCoordinates = function getMinMaxRangeFromDisplayCoordinates(displayCoordinates) {
  var minMaxRange = Object.keys(displayCoordinates).map(function (key) {
    return {
      max: (0, _max["default"])(displayCoordinates[key].map(function (c) {
        return c.y;
      })) || 0,
      min: (0, _min["default"])(displayCoordinates[key].map(function (c) {
        return c.y;
      })) || 0
    };
  });
  var largestValue = (0, _max["default"])(minMaxRange.map(function (c) {
    return c.max;
  }));
  var smallestValue = (0, _min["default"])(minMaxRange.map(function (c) {
    return c.min;
  }));
  return [smallestValue, largestValue];
};

exports.getMinMaxRangeFromDisplayCoordinates = getMinMaxRangeFromDisplayCoordinates;

var getMonthFromJSDate = function getMonthFromJSDate(date) {
  var jsMonth = date.getMonth() + 1;
  return jsMonth.toString().length < 2 ? "0".concat(jsMonth) : jsMonth;
};

var getDayFromJSDate = function getDayFromJSDate(date) {
  var jsDay = date.getDate();
  return jsDay.toString().length < 2 ? "0".concat(jsDay) : jsDay;
};

var jsToDateTime = function jsToDateTime(jsDate, timeZone) {
  var simpleIso = "".concat(jsDate.getFullYear(), "-").concat(getMonthFromJSDate(jsDate), "-").concat(getDayFromJSDate(jsDate));
  return _luxon.DateTime.fromISO(simpleIso, {
    zone: timeZone
  });
};

exports.jsToDateTime = jsToDateTime;